import { useState } from "react";
import {useContextProfile} from "context";
import routes from "routes";

export const useAdminFullPageLayout = () => {
  const {logout, userData} = useContextProfile();
  const [isSidebar, setIsSidebar] = useState<boolean>(false);

  if (userData?.type && userData.type !== 'admin') {
    window.location.pathname = '/' + routes.activity.main;
  }

  const toggleMenu = () => {
    setIsSidebar(!isSidebar);
  }

  return {
    toggleMenu, 
    isSidebar,
    logout
  }
}